import {} from "../mod/index.js";
import {} from "./ImportBinding.js";
import { importOne } from "./importOne.js";
export function importMany(mod, targetMod, bindings) {
    for (const binding of bindings) {
        importOne(mod, targetMod, binding);
    }
}
//# sourceMappingURL=importMany.js.map